import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * Shared page/prev/next control + "Showing X–Y of Z" summary, matching the
 * pattern already established in AdminLeadsDashboard.jsx (previously a
 * private, unused component there — promoted here so every paginated admin
 * list looks the same instead of each page inventing its own).
 */
export default function Pagination({ page, totalPages, total, limit, itemLabel = 'items', onPageChange }) {
  if (totalPages <= 1) return null;

  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '12px 16px',
      background: 'var(--bg-surface)',
      border: '1px solid var(--border)',
      borderRadius: 'var(--radius)',
      marginTop: 16,
    }}>
      <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>
        Showing <strong style={{ color: 'var(--text-primary)' }}>{start}–{end}</strong> of{' '}
        <strong style={{ color: 'var(--text-primary)' }}>{total.toLocaleString()}</strong> {itemLabel}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page === 1}
          className="btn btn-ghost btn-sm"
          aria-label="Previous page"
          style={{ padding: '4px 8px', opacity: page === 1 ? 0.4 : 1 }}
        >
          <ChevronLeft size={14} />
        </button>
        <span style={{
          fontFamily: 'ui-monospace, monospace', fontSize: 12,
          color: 'var(--text-secondary)', minWidth: 70, textAlign: 'center',
        }}>
          {page} / {totalPages}
        </span>
        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page === totalPages}
          className="btn btn-ghost btn-sm"
          aria-label="Next page"
          style={{ padding: '4px 8px', opacity: page === totalPages ? 0.4 : 1 }}
        >
          <ChevronRight size={14} />
        </button>
      </div>
    </div>
  );
}
